<template>
  <div class="nx-signing-modal-complete">
    <h4>Waiting for a file</h4>

    <h5 class="mt-4">Currently, no file id is detected</h5>

    <p class="mt-4">
      <b-spinner />
    </p>
  </div>
</template>

<script>
export default {
  props: {
    value: {},
  },
  watch: {
    "value.fileId": {
      handler(fileId) {
        if (fileId) {
          this.$emit("next");
        }
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.nx-signing-modal-complete {
  text-align: center;
}
</style>
